/* eslint-disable react-hooks/exhaustive-deps */

import { Alert, AlertColor, InputAdornment, Snackbar, Tooltip, useMediaQuery } from "@mui/material";
import React, { FC, useEffect, useRef, useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { getChartList, getDropdownApi } from '../../Services/API';
import { convertNumberToArray, DefaultChoicesNote, dropdownMenu, unregisterMethods, YesorNo } from '../../Utils/common';
import { addressFormat, AppointmentJs, calculativeFieldFormat, captureFormat, contactInfoFormat, countryFormat, currencies, currencyFormat, dateFormat, datetimeFormat, domainFormat, dropDownFormat, emailFormat, employeeDropdownFormat, geolocationFormat, google, htmlFormat, imageMultiselectFormat, imageSelectFormat, inputFormat, inputPhoneFormat, multiInputFormat, multiselectFormat, nameSurnameFormat, paymentFormat, ratingFormat, ratingType, richTextFormat, singleSelectFormat, socialMedia, timeFormat, timeZoneFormat } from '../../Utils/formFields';
import { PaymentPopUp } from '../../Utils/PopupContents';
import CustomizedSingleSelectDropdown from '../CreateForm/DropdownBase';
import CustomCss from '../CustomCss';
import Options from './Options';

import {
  APIMethodContainer,
  CommonSectionContainer,
  CommonTitleSectionContainer,
  RadioSectionContainer,
  RadioTitleSectionContainer,
  RootContainer,
  TextboxSectionContainer,
  TextboxTitleSectionContainer,
  TypeSectionContainer,
  TypeTitleSectionContainer,
} from "./styled";

import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CustomizedInput from '../CreateForm/InputBase';
import CustomizedSwitch from '../CreateForm/SwitchBase';
import { PrimaryButton, SecondaryButton } from '../Custom/Buttons';
import PaymentDetailsModal from '../Custom/Modals/PaymentDetailsModal';
import ResponseFormatModal from '../Custom/Modals/ResponseFormatModal';
import OptionalComponents from './OptionalComponents';
import LandingPageSettings from './OptionalComponents/LandingPageSettings';

import ObjectID from 'bson-objectid';
import InputWithCounter from '../InputWithCounter';
import CalculationInput from './OptionalComponents/CalculationInput';
import './style.scss';

interface Props {
  setQuestionFormData: (e: any) => void;
  setAllValues: (e: any) => void;
  allValues: any; selectedData: any;
  setSelectedData: (e: any) => void;
  isEdit: boolean;
  setAllQuestionTypes: (e: boolean) => void;
  handleDelete: (e: any) => void;
  masterType: any;
  setMasterType: (e: any) => void;
  selectedType: any;
  setSelectedType: (e: any) => void;
  methods: any;
  fieldIndex: any;
  inputType: string;
  setInputType: (e: string) => void;
  setFieldIndex: (e: number) => void;
  submitToggle: boolean;
  submitType: string;
  setSubmitType: (e: string) => void;
  prevSelected: any;
  setFinalQuestionRes: (e: any) => void;
  editUUID: string;
  dataFromModal: any;
  setDragDisable: (e: boolean) => void;
  trigger: boolean;
  addNewIndex: number | null
  setSelectedFormSettings: (e: any) => void;
  setaddNewIndex: (e: number | null) => void;
  errorType: AlertColor;
  setErrorType: (e: AlertColor) => void;
  errorMessage: string
  setErrorMessage: (errorMessage: string) => void;
  toastr: boolean;
  setToastr: (toastr: boolean) => void;
  errorTrigger: boolean;
  historyState: any;
  setHistoryState: (historyState: any) => void;
  redoState: any;
  isfetchFromApi: boolean;
  setIsFetchFromApi: (isfetchFromApi: boolean) => void;
  checked: boolean;
  setChecked: (checked: boolean) => void;
  setRedoState: (redoState: any) => void;
  storeHistory: (field: string, value: any, type: string, optional?: any) => void;
  formValidator: any,
  landingPage: any,
  setDataFromModal: any,
  allQuestionFormData: any,
}

const FormSettings: FC<Props> = ({
  setFinalQuestionRes,
  prevSelected,
  setQuestionFormData,
  setAllValues,
  allValues,
  selectedData,
  setSelectedData,
  isEdit,
  setAllQuestionTypes,
  handleDelete,
  masterType,
  setMasterType,
  selectedType,
  setSelectedType,
  methods,
  fieldIndex,
  inputType,
  setInputType,
  setFieldIndex,
  submitToggle,
  submitType,
  setSubmitType,
  editUUID,
  dataFromModal,
  setDragDisable,
  trigger,
  addNewIndex,
  setSelectedFormSettings,
  setaddNewIndex,
  errorType,
  setErrorType,
  errorMessage,
  setErrorMessage,
  toastr,
  setToastr,
  errorTrigger,
  historyState,
  setHistoryState,
  isfetchFromApi,
  setIsFetchFromApi,
  checked,
  setChecked,
  redoState,
  setRedoState,
  storeHistory,
  formValidator,
  landingPage,
  setDataFromModal,
  allQuestionFormData
}) => {
  const isLessThan1280 = useMediaQuery("(max-width:1279px)");

  const [paymentDetails, setPaymentDetails] = useState<boolean>(false)
  const noRequired = ["input", "phoneNumber", "html", "date", "dateAndTime", "time", "multi-input", "calculation"]
  const [optionCount, setOptionCount] = useState(1);
  const [openCodePopup, setOpenCodePopup] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const firstUpdate = useRef(true);
  const firstErrorUpdate = useRef(true);
  const [chartList, setChartList] = useState<any>([]);


  const handleTypeChange = (type: string, shouldStore: boolean = true) => {
    const prevData = { ...methods.getValues(), type: inputType }
    if (shouldStore) {
      storeHistory('inputType', inputType, "formsettings", { "prevData": prevData })
    }
    setInputType(type)
    switch (type) {
      case "input":
        setMasterType(inputFormat)
        setOptionCount(1)
        methods.reset((formValues: any) => ({ ...formValues, options: inputFormat.options }))
        methods.unregister("isRequired")
        setSelectedType("input")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName")
        break
      case "richText":
        setMasterType(richTextFormat)
        setOptionCount(0)
        methods.reset((formValues: any) => ({ ...formValues }))
        methods.unregister("isRequired")
        setSelectedType("richText")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName")
        break
      case "multi-input":
        setMasterType(multiInputFormat)
        setOptionCount(1)
        methods.reset((formValues: any) => ({ ...formValues, options: multiInputFormat?.options }))
        methods.unregister("isRequired");
        setSelectedType("multi-input");
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName")
        break
      case "select":
        setMasterType(singleSelectFormat)
        setOptionCount(1)
        methods.reset((formValues: any) => ({ ...formValues, options: singleSelectFormat.options }))
        setSelectedType("select")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName")
        break
      case "image-select":
        setMasterType(imageSelectFormat)
        setOptionCount(1)
        methods.reset((formValues: any) => ({ ...formValues, options: imageSelectFormat.options }))
        setSelectedType("image-select")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName")
        break
      case "dropdown":
        setMasterType(dropDownFormat)
        setOptionCount(1)
        methods.reset((formValues: any) => ({ ...formValues, options: singleSelectFormat.options }))
        methods.unregister("dropDependedName")
        setSelectedType("dropdown")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        break
      case "multi-select":
        setMasterType(multiselectFormat)
        setOptionCount(2)
        methods.reset((formValues: any) => ({ ...formValues, options: multiselectFormat.options }))
        setSelectedType("multi-select")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName")
        break
      case "image-multi-select":
        setMasterType(imageMultiselectFormat)
        setOptionCount(2)
        methods.reset((formValues: any) => ({ ...formValues, options: imageMultiselectFormat.options }))
        setSelectedType("image-multi-select")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName")
        break
      case "phoneNumber":
        setOptionCount(1)
        setMasterType(inputPhoneFormat)
        methods.reset((formValues: any) => ({ ...formValues, options: inputPhoneFormat.options }))
        methods.unregister("isRequired")
        setSelectedType("phoneNumber")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName")
        break
      case "html":
        setOptionCount(0)
        setMasterType(htmlFormat)
        methods.reset((formValues: any) => ({ ...formValues }))
        methods.unregister("isRequired")
        methods.unregister("options")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        setSelectedType("html")
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName")
        break
      case "calculation":
        setOptionCount(0)
        setMasterType(calculativeFieldFormat)
        methods.reset((formValues: any) => ({ ...formValues }))
        methods.unregister("isRequired")
        methods.unregister("options")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        setSelectedType("calculation")
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName")
        break
      case "payment":
        setOptionCount(0)
        setMasterType(paymentFormat)
        methods.reset((formValues: any) => ({ ...formValues }))
        methods.unregister("isRequired")
        methods.unregister("options")
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName")
        if (!methods.getValues('currency')) {
          methods.setValue('currency', "EUR")
        }

        setSelectedType("payment")
        if (!selectedData?.fields?.paymentId) {
          setPaymentDetails(true);
        }
        break
      case "date":
        setOptionCount(1)
        setMasterType(dateFormat)
        methods.reset((formValues: any) => ({ ...formValues, options: dateFormat.options }))
        methods.unregister("isRequired")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("dropDependedName")
        methods.unregister("title");
        setSelectedType("date")
        break
      case "dateAndTime":
        setOptionCount(1)
        setMasterType(datetimeFormat)
        methods.reset((formValues: any) => ({ ...formValues, options: datetimeFormat.options }))
        methods.unregister("isRequired")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("dropDependedName")
        methods.unregister("title");
        setSelectedType("dateAndTime")
        break
      case "time":
        setOptionCount(1)
        setMasterType(timeFormat)
        methods.reset((formValues: any) => ({ ...formValues, options: timeFormat.options }))
        methods.unregister("isRequired")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName")
        setSelectedType("time")
        break
      case "nameAndSurname":
        setMasterType(nameSurnameFormat)
        setOptionCount(1)
        methods.reset((formValues: any) => ({ ...formValues, options: nameSurnameFormat.options }))
        methods.unregister("isRequired")
        setSelectedType("nameAndSurname")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("dropDependedName")
        methods.unregister("title");
        break
      case "contactInfo":
        setMasterType(contactInfoFormat)
        setOptionCount(1)
        methods.reset((formValues: any) => ({ ...formValues, options: contactInfoFormat.options }))
        methods.unregister("isRequired")
        setSelectedType("contactInfo")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("dropDependedName")
        methods.unregister("title");
        break
      case "address":
        setMasterType(addressFormat)
        setOptionCount(1)
        methods.reset((formValues: any) => ({ ...formValues, options: addressFormat.options }))
        methods.unregister("isRequired")
        setSelectedType("address")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("dropDependedName")
        methods.unregister("title");
        break
      case "domain":
        setMasterType(domainFormat)
        setOptionCount(1)
        methods.reset((formValues: any) => ({ ...formValues, options: domainFormat.options }))
        unregisterMethods(methods,
          ["isRequired",
            "paymentId",
            "currency",
            "amount",
            "name",
            "title",
            "dropDependedName",
            "description",
          ])
        setSelectedType("domain")
        break
      case "currency":
        setMasterType(currencyFormat)
        setOptionCount(1)
        methods.reset((formValues: any) => ({ ...formValues, options: currencyFormat.options }))
        unregisterMethods(methods,
          ["isRequired",
            "paymentId",
            "currency",
            "amount",
            "name",
            "title",
            "dropDependedName",
            "description",
          ])
        setSelectedType("currency")
        break
      case "email":
        setMasterType(emailFormat)
        setOptionCount(1)
        methods.reset((formValues: any) => ({ ...formValues, options: emailFormat.options }))
        unregisterMethods(methods,
          ["isRequired",
            "paymentId",
            "currency",
            "amount",
            "name",
            "title",
            "dropDependedName",
            "description",
          ])
        setSelectedType("email")
        break
      case "appointment":
        setOptionCount(0)
        setMasterType(AppointmentJs)
        methods.reset((formValues: any) => ({ ...formValues }))
        unregisterMethods(methods,
          ["isRequired",
            "options",
            "paymentId",
            "currency",
            "amount",
            "description",
            "name",
            "dropDependedName",
            "title"])
        setSelectedType("appointment")
        break
      case "country":
        setMasterType(countryFormat)
        setOptionCount(0)
        methods.reset((formValues: any) => ({ ...formValues }))
        setSelectedType("country")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName");
        break
      case "geolocation":
        setMasterType(geolocationFormat)
        setOptionCount(0)
        methods.reset((formValues: any) => ({ ...formValues }))
        methods.unregister("isRequired")
        setSelectedType("geolocation")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName")
        break
      case "timezone":
        setMasterType(timeZoneFormat)
        setOptionCount(0)
        methods.reset((formValues: any) => ({ ...formValues }))
        setSelectedType("timezone")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        methods.unregister("dropDependedName");
        break

      case "rating":
        setMasterType(ratingFormat)
        setOptionCount(0)
        methods.reset(() => ({ ...ratingFormat }))
        unregisterMethods(methods,
          ["options",
            "paymentId",
            "currency",
            "name",
            "title",
            "description",
            "dropDependedName",
            "amount"])
        setSelectedType("rating")
        break

      case "linkedin":
        setOptionCount(0)
        setMasterType(socialMedia)
        methods.reset((formValues: any) => ({ ...formValues }))
        unregisterMethods(methods,
          [
            "options",
            "paymentId",
            "currency",
            "name",
            "title",
            "description",
            "dropDependedName",
            "amount"])
        setSelectedType("linkedin")
        break

      case "google":
        setOptionCount(0)
        setMasterType(google)
        methods.reset((formValues: any) => ({ ...formValues }))
        unregisterMethods(methods,
          [
            "options",
            "paymentId",
            "currency",
            "name",
            "title",
            "description",
            "dropDependedName",
            "amount"])
        setSelectedType("google")
        break

      case "twitter":
        setOptionCount(0)
        setMasterType(socialMedia)
        methods.reset((formValues: any) => ({ ...formValues }))
        unregisterMethods(methods,
          [
            "options",
            "paymentId",
            "currency",
            "name",
            "title",
            "description",
            "dropDependedName",
            "amount"])
        setSelectedType("twitter")
        break

      case "facebook":
        setOptionCount(0)
        setMasterType(socialMedia)
        methods.reset((formValues: any) => ({ ...formValues }))
        unregisterMethods(methods,
          [
            "options",
            "paymentId",
            "currency",
            "name",
            "title",
            "description",
            "dropDependedName",
            "amount"])
        setSelectedType("facebook")
        break

      case "openproject":
        setOptionCount(0)
        setMasterType(socialMedia)
        methods.reset((formValues: any) => ({ ...formValues }))
        unregisterMethods(methods,
          [
            "options",
            "paymentId",
            "currency",
            "name",
            "title",
            "description",
            "dropDependedName",
            "amount"])
        setSelectedType("openproject")
        break

      case "tiktok":
        setOptionCount(0)
        setMasterType(socialMedia)
        methods.reset((formValues: any) => ({ ...formValues }))
        unregisterMethods(methods,
          [
            "options",
            "paymentId",
            "currency",
            "name",
            "title",
            "description",
            "dropDependedName",
            "amount"])
        setSelectedType("tiktok")
        break
      case "employee":
        setMasterType(employeeDropdownFormat)
        setOptionCount(1)
        methods.reset((formValues: any) => ({ ...formValues, options: singleSelectFormat.options }))
        setSelectedType("employee")
        methods.unregister("paymentId");
        methods.unregister("currency");
        methods.unregister("amount");
        methods.unregister("name");
        methods.unregister("description");
        methods.unregister("title");
        break

      case "capture":
        setOptionCount(0)
        setMasterType(captureFormat)
        methods.reset((formValues: any) => ({ ...formValues }))
        unregisterMethods(methods,
          [
            "options",
            "paymentId",
            "currency",
            "name",
            "title",
            "description",
            "dropDependedName",
            "amount"])
        setSelectedType("capture")
        break

    }
  }


  const onSubmit = async (data: any, type: string = "") => {
    try {
      const clone = [...allValues];
      data['type'] = selectedType === "html" ? "next" : selectedType;

      if ((selectedData?.index || selectedData?.index === 0)) {
        const updatedData = { ...data, dependedId: clone[selectedData.index]?.dependedId, isDepended: clone[selectedData.index]?.isDepended }
        clone[selectedData.index] = updatedData;
        setAllValues([...clone])
        setQuestionFormData([...clone]);
        if (submitType !== "selection" && submitType !== "finalSubmit" && submitType !== 'duplicate') {
          setAllQuestionTypes(true);
          setSelectedType("select");
          setInputType("select")
          setMasterType(singleSelectFormat)
          setOptionCount(1)
        }
      } else {
        if (submitType !== "selection" && submitType !== "finalSubmit" && submitType !== 'add-middle' && submitType !== 'duplicate') {
          setAllValues([...allValues, data])
          setQuestionFormData([...allValues, data]);
        } else if (submitType === 'add-middle' && (addNewIndex || addNewIndex === 0)) {
          allValues.splice(addNewIndex + 1, 0, data)
          setAllValues([...allValues])
          setQuestionFormData([...allValues]);
        }
      }
      if (submitType === "selection") {
        setSelectedData({ ...prevSelected })
      }

      if (!isEdit && selectedData?.index === clone.length - 1 && submitType !== 'selection' && submitType !== "finalSubmit") {
        methods.reset(masterType)
      }
      if (submitType === 'duplicate' && (addNewIndex || addNewIndex === 0)) {
        const duplicateData = JSON.parse(JSON.stringify(clone[addNewIndex]))
        duplicateData['name'] = duplicateData['name'] + ' (copy)'
        duplicateData['title'] = duplicateData['title'] + ' (copy)'
        duplicateData['_id'] = ObjectID().toString()
        storeHistory('duplicate-question', { data: duplicateData, index: addNewIndex + 1 }, 'form-content')
        clone.splice(addNewIndex + 1, 0, duplicateData)
        setAllValues([...clone])
        setSelectedFormSettings({ index: addNewIndex + 1, fields: duplicateData })
      }
      setFinalQuestionRes("success")
      setSubmitType("")
      setTimeout(() => {
        setaddNewIndex(null)
      }, 200)//need this little delay to perform an operation in another function.
    } catch (e) {
      console.log("err in add", e)
    }
  }

  const handlefetchFromApi = (e: boolean) => {
    setIsFetchFromApi(e)
    methods.setValue('fetchFromApi', e)
    if (!e) {
      methods.unregister('dropdownApiData')
    }
    methods.setValue('dropdownApiData.dropdown_maxVal', 0)
  }


  const handleTestApi = async () => {
    try {
      if (methods.watch('dropdownApiData.dropdown_endPointHeaders')) {
        try {
          JSON.parse(methods.watch('dropdownApiData.dropdown_endPointHeaders'));
          if (!Object.keys(JSON.parse(methods.watch('dropdownApiData.dropdown_endPointHeaders') || "{}")).length) {
            throw new Error("invalid Headers")
          }
        } catch (e: any) {
          methods.setError('dropdown_endPoint', { type: "custom", message: "invalid headers" })
          setToastr(true)
          setErrorMessage('invalid headers')
          setErrorType('error')
        }
      }
      setLoading(true)
      const res = await getDropdownApi(methods.watch('dropdownApiData'))
      if (res?.data?.dropdownData?.length) {
        let includedCount = 0
        res?.data?.dropdownData?.forEach((data: any) => {
          if (Object.keys(data).includes('label') && Object.keys(data).includes('value')) {
            includedCount++
          }
        })
        if (includedCount > 1) {
          setErrorType('success')
          throw new Error('Api is working as expected')
        } else {
          setErrorType('error')
          throw new Error("Wrong response")
        }
      } else {
        setErrorType('error')
        throw new Error("Wrong response")

      }
    } catch (e: any) {
      setLoading(false)
      setErrorMessage(e.message)
      setToastr(true)
    }
  }

  const handleFetchChartList = async () => {
    try {
      const orgData = await getChartList(sessionStorage?.principalId);
      if (orgData?.statusCode === 200 && orgData?.data?.chartsDetails?.length > 0) {
        let chartsDetails = orgData?.data?.chartsDetails;
        chartsDetails = chartsDetails.map((chart: any) => {
          return {
            label: chart?.organisationDetails?.name,
            value: chart?._id
          }
        })
        setChartList(chartsDetails);
      } else {
        setChartList([]);
      }
    } catch (error) {
      console.log(error, "error in get chart list")
    }
  }

  useEffect(() => {
    if (sessionStorage?.principalId) {
      handleFetchChartList();
    }
  }, [sessionStorage?.principalId]);


  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    onSubmit(methods.getValues())
  }, [submitToggle])

  useEffect(() => {
    if (firstErrorUpdate.current) {
      firstErrorUpdate.current = false;
      return;
    }
    setTimeout(() => { methods.trigger() }, 100) //need this little delay to perform an operation in another function.
  }, [errorTrigger])

  useEffect(() => {
    if (methods.watch('fetchFromApi')) {
      setIsFetchFromApi(true)
    }
  }, [methods.getValues('fetchFromApi')])

  useEffect(() => {

    if (selectedData?.fields) {
      methods.reset(selectedData.fields)
      setChecked(selectedData?.field?.isRequired ?? methods.getValues('isRequired'));
    }
    if (selectedData?.fields?.type) {
      handleTypeChange(selectedData?.fields?.type === "next" ? "html" : selectedData?.fields?.type, false)
    }
    else {
      handleTypeChange('select', false)
    }
    if (selectedData?.fields?.options?.length) {
      setOptionCount(1)
    }
    else {
      setOptionCount(0)
    }
    methods.setValue('isRequired', selectedData?.fields?.isRequired ? true : false);
    methods.reset(selectedData?.fields || masterType);
  }, [selectedData])

  useEffect(() => {
    if (Object.keys(methods.formState.errors || {}).length) {
      setDragDisable(true)
    } else {
      setDragDisable(false)
    }
  }, [Object.keys(methods.formState.errors || {})])

  useEffect(() => {
    methods.trigger()
  }, [trigger])

  useEffect(() => {
    methods.reset(handleTypeChange(masterType))
  }, [])

  const renderTitleField = (fields: any, index: number) => {
    if (selectedType === "html" && fields === "title") {
      return (
        <TextboxSectionContainer>
          <TextboxTitleSectionContainer>
            Question *
          </TextboxTitleSectionContainer>
          <CustomizedInput
            {...methods.register("title", { required: true })}
            placeholder="Type here"
            value={formValidator.getValues("title") ?? ""}
            onChange={(e: any) => {
              formValidator.setValue("title", e.target.value);
              storeHistory(fields, e.target.value, "formsettings");
              setRedoState([]);
            }}
          />
        </TextboxSectionContainer>
      );
    }

    return <React.Fragment />;
  };

  const renderPaymentField = (fields: any, index: number) => {
    if (fields === "paymentId") {
      return (
        <TextboxSectionContainer>
          <TextboxTitleSectionContainer>
            Payment Id
          </TextboxTitleSectionContainer>
          <CustomizedInput
            {...methods.register(fields, { required: true })}
            placeholder="Type here"
            readOnly={true}
            value={formValidator.getValues(fields) ?? ""}
            onClick={() => {
              setPaymentDetails(true);
            }}
            onChange={(e: any) => {
              formValidator.setValue(fields, e.target.value);
              storeHistory(fields, e.target.value, "formsettings");
              setRedoState([]);
            }}
          />
        </TextboxSectionContainer>
      );
    }

    return <React.Fragment />;
  };

  const renderCurrencyField = (fields: any, index: number) => {
    if (fields === "currency") {
      return (
        <CommonSectionContainer isLargeScreen={!isLessThan1280} style={{ marginTop: "25px" }}>
          <CommonTitleSectionContainer isLargeScreen={!isLessThan1280}>
            Currency
          </CommonTitleSectionContainer>
          <CustomizedSingleSelectDropdown
            dataProvider={currencies}
            value={methods.watch(fields) || "EUR"}
            setValue={(e: string) => {
              storeHistory(fields, methods.watch(fields), "formsettings");
              methods.setValue(fields, e);
              setRedoState([]);
            }}
          />
        </CommonSectionContainer>
      );
    }

    return <React.Fragment />;
  };

  const renderAmountField = (fields: any, index: number) => {
    if (fields === "amount") {
      return (
        <TextboxSectionContainer>
          <TextboxTitleSectionContainer>
            Amount *
          </TextboxTitleSectionContainer>
          <CustomizedInput
            type='number'
            placeholder="Type here"
            value={formValidator.getValues(fields)}
            onChange={(e: any) => {
              formValidator.setValue(fields, e.target.value);
              storeHistory(fields, e.target.value, "formsettings");
              setRedoState([]);
            }}
          />
        </TextboxSectionContainer>
      );
    }

    return <React.Fragment />;
  };

  const renderIsRequiredField = (fields: any, index: number) => {
    if (fields === "isRequired" && !noRequired.includes(inputType)) {
      return (
        <RadioSectionContainer>
          <RadioTitleSectionContainer>
            Required Field
          </RadioTitleSectionContainer>
          <CustomizedSwitch
            checked={checked ?? false}
            changeHandler={(e: any) => {
              storeHistory(fields, checked, "formsettings");
              setChecked(e.target.checked);
              formValidator.setValue(fields, e.target.checked);
              setRedoState([]);
            }}
          />
        </RadioSectionContainer>
      );
    }

    return <React.Fragment />;
  };

  const renderYesNoToggle = (fields: any) => {
    if (fields === "options" && inputType === "select") {
      return (
        <RadioSectionContainer>
          <RadioTitleSectionContainer>
            Yes/No Question
          </RadioTitleSectionContainer>
          <CustomizedSwitch
            checked={methods.watch("isYesNo") ?? false}
            changeHandler={(e: any) => {
              const isChecked = e.target.checked;
              storeHistory("isYesNo", isChecked, "formsettings");
              methods.setValue("isYesNo", isChecked);

              if (isChecked) {
                methods.setValue("options", YesorNo);
                methods.setValue("isOtherEnabled", false);
              } else {
                methods.setValue("options", singleSelectFormat.options);
              }
              setRedoState([]);
            }}
          />
        </RadioSectionContainer>
      );
    }
    return <React.Fragment />;
  };

  const renderSendFileToApi = (fields: any) => {
    if (inputType === "input") {

      const handleSaveEndpoint = (e: React.ChangeEvent<HTMLInputElement>) => {
        formValidator.setValue("postApiDetails", { endpoint: e.target.value })
      }

      const choosenInputs = methods.watch(`options`)?.map((option: any) => option.type)
      if (fields === "sendFileToApi" && choosenInputs?.includes("file")) {
        return (
          <div>
            <RadioSectionContainer>
              <RadioTitleSectionContainer>
                Send File To API
              </RadioTitleSectionContainer>
              <CustomizedSwitch
                checked={methods.watch("sendFileToApi") ?? false}
                changeHandler={(e: any) => {
                  storeHistory(fields, methods.watch("sendFileToApi"), "formsettings");
                  formValidator.setValue(fields, e.target.checked);
                  if (!e.target.checked) {
                    formValidator.setValue("postApiDetails", { endpoint: "" })
                  }
                  setRedoState([]);
                }}
              />
            </RadioSectionContainer>
            {methods.watch("sendFileToApi") && <>
              <CustomizedInput placeholder="Enter your endpoint" value={methods.watch("postApiDetails")?.endpoint || ""} onChange={handleSaveEndpoint} />
            </>}
          </div>
        );
      }
    }

    return <React.Fragment />;
  };

  const renderIsSearchEnabled = (fields: any, index: number) => {

    if (fields === "isSearchEnabled") {
      return (
        <RadioSectionContainer>
          <RadioTitleSectionContainer>
            Search
          </RadioTitleSectionContainer>
          <CustomizedSwitch
            checked={formValidator.getValues("isSearchEnabled") ?? false}
            changeHandler={(e: any) => {
              storeHistory(fields, checked, "formsettings");
              formValidator.setValue("isSearchEnabled", e.target.checked)
              if (!e.target.checked) {
                formValidator.setValue('dropdownApiData.isAdvancedSearch', false);
              }
              formValidator.setValue('dropdownApiData.dropdown_maxVal', '0');
              setRedoState([]);
            }}
          />
        </RadioSectionContainer>
      );
    }

    return <React.Fragment />;
  };

  const renderIsOtherEnabledField = (fields: any, index: number) => {
    if (fields === "isOtherEnabled") {
      const handleChecked = (isChecked: boolean) => {
        let options = methods.getValues('options');
        if (isChecked) {
          options.push({ type: "otherField", isOtherEnabled: true, label: "Other" })
        } else {
          options = options.filter((ele: any) => ele?.type !== "otherField")
        }
        methods.setValue('options', options);
      };

      return (
        <RadioSectionContainer>
          <RadioTitleSectionContainer>
            Other Option
          </RadioTitleSectionContainer>
          <CustomizedSwitch
            checked={methods.watch(fields)}
            changeHandler={(e: any) => {
              storeHistory(fields, methods.watch(fields), "formsettings");
              methods.setValue(fields, e.target.checked);
              handleChecked(e.target.checked)
            }}
          />
        </RadioSectionContainer>
      );
    }

    return <React.Fragment />;
  };

  const setIsTimeLimitEnabledValue = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const checked = event.target.checked;
    const fieldName = "isTimeLimitEnabled";

    storeHistory(fieldName, methods.watch(fieldName), "formsettings");
    methods.setValue(fieldName, checked);
    setTimeLimitValue("");
  };

  const setTimeLimitValue = (value: string) => {
    const fieldName = "timeLimit";

    storeHistory(fieldName, methods.watch(fieldName), "formsettings");
    methods.setValue(fieldName, value);
  };

  const timeLimitChangeHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const value = event.target.value;
    const isStringValid = /^(|\d+|[1-9]\d*[ms])$/.test(value);

    if (isStringValid) {
      setTimeLimitValue(value);
    }
  };

  const timeLimitBlurHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const isStringValid = /^[1-9]\d*[ms]$/.test(value);
    const isStringContainsOnlyNumbers = /^[1-9]\d*$/.test(value);

    if (isStringValid) {
      return;
    }

    if (isStringContainsOnlyNumbers) {
      setTimeLimitValue(`${value}s`);
      return;
    }
  };

  const renderIsTimeRequiredField = (fields: any, index: number) => {
    if (fields === "isTimeLimitEnabled") {
      const isTimeLimitEnabled = methods.watch("isTimeLimitEnabled");
      const timeLimit = methods.watch("timeLimit");

      return (
        <React.Fragment>
          <RadioSectionContainer>
            <RadioTitleSectionContainer>
              Time Required
            </RadioTitleSectionContainer>
            <CustomizedSwitch
              checked={isTimeLimitEnabled}
              changeHandler={setIsTimeLimitEnabledValue}
            />
          </RadioSectionContainer>
          {isTimeLimitEnabled && (
            <TextboxSectionContainer style={{ marginTop: "15px" }}>
              <TextboxTitleSectionContainer>
                Time Limit *
              </TextboxTitleSectionContainer>
              <CustomizedInput
                value={timeLimit}
                placeholder="Type here"
                onBlur={timeLimitBlurHandler}
                onChange={timeLimitChangeHandler}
              />
            </TextboxSectionContainer>
          )}
        </React.Fragment>
      );
    }

    return <React.Fragment />;
  };

  const renderAppointmentField = (fields: any, index: number) => {
    if (fields === "appointment_id") {
      return (
        <TextboxSectionContainer>
          <TextboxTitleSectionContainer>Appointment Id *</TextboxTitleSectionContainer>
          <CustomizedInput
            placeholder="Type here"
            {...methods.register(fields, { required: true })}
            value={formValidator.getValues(fields) ?? ""}
            onChange={(e: any) => {
              formValidator.setValue(fields, e.target.value);
              storeHistory(fields, e.target.value, "formsettings");
              setRedoState([]);
            }}
          />
        </TextboxSectionContainer>
      );
    }

    return <React.Fragment />;
  };

  const renderDropDependedName = (fields: any) => {
    if (fields === "dropDependedName") {
      return (
        <TextboxSectionContainer>
          <div className='key-with-icon'>
            <TextboxTitleSectionContainer>
              Depended Dropdown ID
            </TextboxTitleSectionContainer>
            <Tooltip title="This must be same as depended dropdown question"><HelpOutlineIcon /></Tooltip>
          </div>
          <CustomizedInput
            placeholder="Type here"
            value={methods.watch("dropDependedName") ?? ""}
            onChange={(e: any) => {
              methods.setValue(
                "dropDependedName",
                e.target.value
              );
              if (methods.watch("dropDependedName")) {
                methods.setValue(
                  "fetchFromApi", false
                );
              }
              methods.clearErrors();
              setRedoState([]);
            }}
            type="text"
          />
        </TextboxSectionContainer>
      );
    }

    return <React.Fragment />;
  };

  const renderFetchFromAPIField = (fields: any, index: number) => {
    if (fields === "fetchFromApi") {
      return (
        <React.Fragment>
          <RadioSectionContainer>
            <RadioTitleSectionContainer>
              Fetch Options from API
            </RadioTitleSectionContainer>
            <CustomizedSwitch
              checked={formValidator.watch('fetchFromApi') ?? false}
              changeHandler={(e: any) => {
                handlefetchFromApi(e.target.checked);
                storeHistory(fields, !e.target.checked, "formsettings");
                methods.setValue(
                  "dropDependedName",
                  ""
                );
                setRedoState([]);
                if (e.target.checked && !methods.watch("dropdownApiData.dropdown_maxVal")) {
                  methods.setValue(
                    "dropdownApiData.dropdown_maxVal",
                    '0'
                  )
                }
              }}
            />
          </RadioSectionContainer>
          {formValidator.watch('fetchFromApi') && (
            <React.Fragment>
              <TextboxSectionContainer>
                <TextboxTitleSectionContainer>
                  API Url *
                </TextboxTitleSectionContainer>
                <CustomizedInput
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <APIMethodContainer>GET</APIMethodContainer>
                      </InputAdornment>
                    )
                  }}
                  placeholder="Type here"
                  value={methods.watch("dropdownApiData.dropdown_endPoint") ?? ""}
                  onChange={(e: any) => {
                    methods.setValue(
                      "dropdownApiData.dropdown_endPoint",
                      e.target.value
                    );
                    methods.clearErrors();
                    setRedoState([]);
                  }}
                />
              </TextboxSectionContainer>
              <TextboxSectionContainer>
                <TextboxTitleSectionContainer>
                  Headers
                </TextboxTitleSectionContainer>
                <CustomizedInput
                  placeholder="Type here"
                  {...methods.register(
                    "dropdownApiData.dropdown_endPointHeaders"
                  )}
                  value={methods.watch(
                    "dropdownApiData.dropdown_endPointHeaders"
                  ) ?? ""}
                  onChange={(e: any) => {
                    methods.setValue(
                      "dropdownApiData.dropdown_endPointHeaders",
                      e.target.value
                    );
                    methods.clearErrors();
                    setRedoState([]);
                  }}
                />
              </TextboxSectionContainer>
              {formValidator.watch("isSearchEnabled") && <TextboxSectionContainer>
                <TextboxTitleSectionContainer>
                  Max values to display * (0 displays everything)
                </TextboxTitleSectionContainer>
                <CustomizedInput
                  placeholder="Type here"
                  {...methods.register("dropdownApiData.dropdown_maxVal")}
                  value={methods.watch("dropdownApiData.dropdown_maxVal") ?? "0"}
                  onChange={(e: any) => {
                    methods.setValue(
                      "dropdownApiData.dropdown_maxVal",
                      e.target.value
                    );
                    methods.clearErrors();
                    setRedoState([]);
                  }}
                  type="number"
                />
              </TextboxSectionContainer>}
              {formValidator.watch("isSearchEnabled") && <>
                <RadioSectionContainer>
                  <RadioTitleSectionContainer>
                    Advanced Search
                  </RadioTitleSectionContainer>
                  <CustomizedSwitch
                    checked={formValidator.watch('dropdownApiData.isAdvancedSearch') ?? false}
                    changeHandler={(e: any) => {
                      formValidator.setValue('dropdownApiData.isAdvancedSearch', e.target.checked);
                      storeHistory(fields, !e.target.checked, "formsettings");
                      setRedoState([]);
                    }}
                  />
                </RadioSectionContainer>
                {formValidator.watch('dropdownApiData.isAdvancedSearch') && <>
                  <TextboxSectionContainer>
                    <TextboxTitleSectionContainer>
                      Search parameter
                    </TextboxTitleSectionContainer>
                    <CustomizedInput
                      placeholder="Type here"
                      {...methods.register("dropdownApiData.searchKey")}
                      value={methods.watch("dropdownApiData.searchKey") ?? ""}
                      onChange={(e: any) => {
                        methods.setValue(
                          "dropdownApiData.searchKey",
                          e.target.value
                        );
                        methods.clearErrors();
                        setRedoState([]);
                      }}
                      type="text"
                    />
                  </TextboxSectionContainer>
                  <TextboxSectionContainer>
                    <TextboxTitleSectionContainer>
                      Minimum letter for search
                    </TextboxTitleSectionContainer>
                    <CustomizedInput
                      placeholder="Type here"
                      {...methods.register("dropdownApiData.searchAfterLength")}
                      value={methods.watch("dropdownApiData.searchAfterLength") ?? ""}
                      onChange={(e: any) => {
                        methods.setValue(
                          "dropdownApiData.searchAfterLength",
                          e.target.value
                        );
                        methods.clearErrors();
                        setRedoState([]);
                      }}
                      type="number"
                    />
                  </TextboxSectionContainer>
                </>}
              </>
              }
              {!formValidator.watch('dropdownApiData.isAdvancedSearch') && <PrimaryButton
                style={{ width: 200, margin: 5 }}
                disabled={!methods.watch("dropdownApiData.dropdown_endPoint") || loading}
                onClick={handleTestApi}
              >
                Test API
              </PrimaryButton>}
              <SecondaryButton
                style={{ width: 200, margin: 5 }}
                onClick={() => setOpenCodePopup(true)}
              >
                View Sample Response
              </SecondaryButton>
              <div style={{ marginTop: 10 }}>
                <DefaultChoicesNote />
              </div>
            </React.Fragment>
          )}
        </React.Fragment>
      );
    }

    return <React.Fragment />;
  };

  const renderCallApiOnSelection = (fields: any) => {
    if (fields === "callApiOnSelect") {
      let validInput = true;
      if (methods.getValues('type') === "input") {
        validInput = methods.getValues('options').length === 1 && methods.getValues('options')[0].type !== "file"
      }

      return (
        <React.Fragment>
          <Tooltip title={validInput ? ""
            : methods.getValues('options')[0].type === "file"
              ? "This option cannot be enabled for file input"
              : "This option cannot be enabled for multiple input files"
          } >
            <RadioSectionContainer>
              <RadioTitleSectionContainer>
                Make a dropdown option based on selection
              </RadioTitleSectionContainer>
              <CustomizedSwitch
                checked={methods.watch('callApiOnSelect.isActivated') ?? false}
                changeHandler={(e: any) => {
                  if (validInput) {
                    methods.setValue('callApiOnSelect.isActivated', e.target.checked);
                    if (!e.target.checked) {
                      methods.setValue('callApiOnSelect', { isActivated: false })
                    }
                    storeHistory(fields, !e.target.checked, "formsettings");
                    setRedoState([]);
                  }
                }}
              />
            </RadioSectionContainer>
          </Tooltip>
          {
            formValidator.watch('callApiOnSelect.isActivated') && (
              <React.Fragment>
                <TextboxSectionContainer>
                  <TextboxTitleSectionContainer>
                    API Url *
                  </TextboxTitleSectionContainer>
                  <CustomizedInput
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <APIMethodContainer>GET</APIMethodContainer>
                        </InputAdornment>
                      )
                    }}
                    placeholder="Type here"
                    value={methods.watch("callApiOnSelect.dropdown_endPoint") ?? ""}
                    onChange={(e: any) => {
                      methods.setValue(
                        "callApiOnSelect.dropdown_endPoint",
                        e.target.value
                      );
                      methods.clearErrors();
                      setRedoState([]);
                    }}
                  />
                </TextboxSectionContainer>
                <TextboxSectionContainer>
                  <TextboxTitleSectionContainer>
                    Headers
                  </TextboxTitleSectionContainer>
                  <CustomizedInput
                    placeholder="Type here"
                    {...methods.register(
                      "callApiOnSelect.dropdown_endPointHeaders"
                    )}
                    value={methods.watch(
                      "callApiOnSelect.dropdown_endPointHeaders"
                    ) ?? ""}
                    onChange={(e: any) => {
                      methods.setValue(
                        "callApiOnSelect.dropdown_endPointHeaders",
                        e.target.value
                      );
                      methods.clearErrors();
                      setRedoState([]);
                    }}
                  />
                </TextboxSectionContainer>
                <TextboxSectionContainer>
                  <TextboxTitleSectionContainer>
                    Search parameter
                  </TextboxTitleSectionContainer>
                  <CustomizedInput
                    placeholder="Type here"
                    {...methods.register("callApiOnSelect.searchKey")}
                    value={methods.watch("callApiOnSelect.searchKey") ?? ""}
                    onChange={(e: any) => {
                      methods.setValue(
                        "callApiOnSelect.searchKey",
                        e.target.value
                      );
                      methods.clearErrors();
                      setRedoState([]);
                    }}
                    type="text"
                  />
                </TextboxSectionContainer>
                <TextboxSectionContainer>
                  <div className='key-with-icon'>
                    <TextboxTitleSectionContainer>
                      Depended Dropdown ID
                    </TextboxTitleSectionContainer>
                    <Tooltip title="This must be same as depended dropdown question"><HelpOutlineIcon /></Tooltip>
                  </div>
                  <CustomizedInput
                    placeholder="Type here"
                    value={methods.watch("callApiOnSelect.dropDependedName") ?? ""}
                    onChange={(e: any) => {
                      methods.setValue(
                        "callApiOnSelect.dropDependedName",
                        e.target.value
                      );
                      methods.clearErrors();
                      setRedoState([]);
                    }}
                    type="text"
                  />
                  <Tooltip title="Copy and Paste the Generated ID to Depended Dropdown ID of the depended Dropdown question">
                    <PrimaryButton
                      style={{ width: 200, margin: 5 }}
                      onClick={() => {
                        methods.setValue(
                          "callApiOnSelect.dropDependedName",
                          Math.floor(100000 + Math.random() * 900000)
                        );
                      }}
                    >
                      Generate ID
                    </PrimaryButton>
                  </Tooltip>
                </TextboxSectionContainer>
                <SecondaryButton
                  style={{ width: 200, margin: 5 }}
                  onClick={() => setOpenCodePopup(true)}
                >
                  View Sample Response
                </SecondaryButton>
                <div style={{ marginTop: 10 }}>
                  <DefaultChoicesNote />
                </div>
              </React.Fragment>
            )
          }
        </React.Fragment >
      );
    }

    return <React.Fragment />;
  }

  const hasOptions = (type: string) => {
    const showIf = ["html", "dropdown", "payment", "appointment", "linkedin", "country", "timezone", "rating", "google", "twitter", "openproject", "facebook", "tiktok", "calculation", "employee", "richText", "geolocation", "capture"];

    if (type.length) {
      return !Boolean(showIf.includes(type));
    }

    return false;
  };

  const hasSelect = (type: string) => {
    const showIf = ["select", "multi-select"];

    if (type.length) {
      return Boolean(showIf.includes(type));
    }

    return false;
  };

  const renderVariableRule = (field: any) => {
    if (field === "calculationRules") {
      return (
        <CalculationInput isLessThan1280={isLessThan1280} methods={methods} setRedoState={setRedoState} />
      )
    }
    return <React.Fragment></React.Fragment>
  }

  const renderOptionsPanel = (fields: any, index: number, value: any) => {
    if (
      fields === "options" &&
      fieldIndex != null &&
      !["calculation", "html", "dropdown", "country", "timezone", "employee"].includes(inputType) &&
      optionCount > 0
    ) {
      return (
        <Options
          selectedType={selectedType}
          NoOfOptions={optionCount}
          value={value}
          selectedData={selectedData}
          fieldIndex={fieldIndex}
          setFieldIndex={setFieldIndex}
          storeHistory={storeHistory}
          resetRedo={() => setRedoState([])}
          editUUID={editUUID}
          restrictAddInput={methods.watch('callApiOnSelect.isActivated') || methods.watch('isYesNo')}
        />
      );
    }
  };

  const renderRatingType = (fields: any, index: number) => {

    if (fields === "ratingSettings") {
      return (
        <>
          <CommonTitleSectionContainer isLargeScreen={!isLessThan1280}>
            Type
          </CommonTitleSectionContainer>
          <CustomizedSingleSelectDropdown
            value={methods.watch('ratingSettings')?.isStar
              ? "star"
              : methods.watch('ratingSettings')?.ratingType === "emoji" ? "emoji"
                : methods.watch('ratingSettings')?.ratingType === "thumbs" ? "thumbs"
                  : methods.watch('ratingSettings')?.ratingType === "slider" ? "slider"
                    : "opinion"
            }
            dataProvider={ratingType}
            setValue={(e: string) => {
              storeHistory(
                `ratingSettings.isStar`,
                methods.watch(`ratingSettings.isStar`),
                "formsettings"
              );
              methods.setValue(`ratingSettings.isStar`, e === "star" ? true : false);
              if (e === "star") {
                methods.setValue(`ratingSettings`, {
                  "isStar": true,
                  "max": 10
                })
              } else if (["emoji", "thumbs", "slider"].includes(e)) {
                methods.setValue(`ratingSettings`, {
                  "isStar": false,
                  "isStyledRating": true,
                  "ratingType": e
                })
              }
              else {
                methods.setValue(`ratingSettings`, {
                  "isStar": false,
                  "min": 0,
                  "max": 10,
                  "label": {
                    "start": "",
                    "mid": "",
                    "end": ""
                  }
                })
              }
              setRedoState([]);

            }}
          />
          {!methods.watch(`ratingSettings.isStar`) && !methods.watch(`ratingSettings.isStyledRating`) && <> <CommonTitleSectionContainer isLargeScreen={!isLessThan1280}>
            Min
          </CommonTitleSectionContainer>
            <CustomizedSingleSelectDropdown
              value={methods.watch('ratingSettings')?.min}
              dataProvider={convertNumberToArray(0, 1)?.map((data: any) => { return { label: data, value: data } })}
              setValue={(e: string) => {
                storeHistory(
                  `ratingSettings.min`,
                  methods.watch(`ratingSettings`).min,
                  "formsettings"
                );
                methods.setValue(`ratingSettings.min`, e);
                setRedoState([]);
              }}
            /></>}
          {!methods.watch(`ratingSettings.isStyledRating`) && <><CommonTitleSectionContainer isLargeScreen={!isLessThan1280}>
            Max
          </CommonTitleSectionContainer>
            <CustomizedSingleSelectDropdown
              value={methods.watch('ratingSettings')?.max}
              dataProvider={convertNumberToArray(methods.watch(`ratingSettings.isStar`) ? 2 : 5, 10)?.map((data: any) => { return { label: data, value: data } })}
              setValue={(e: string) => {
                storeHistory(
                  `ratingSettings.max`,
                  methods.watch(`ratingSettings`)?.max,
                  "formsettings"
                );
                methods.setValue(`ratingSettings.max`, e);
                setRedoState([]);
              }}
            />
          </>
          }
          {
            !methods.watch(`ratingSettings.isStar`) && !methods.watch(`ratingSettings.isStyledRating`) && <>
              <InputWithCounter
                placeHolder={'Min label'}
                value={methods.watch("ratingSettings.label.start") ?? ""}
                onChangeHandler={(e: any) => {
                  methods.setValue(
                    "ratingSettings.label.start",
                    e
                  );
                  methods.clearErrors();
                  setRedoState([]);
                }}
                maxCount={24}
              />
              <InputWithCounter
                placeHolder={'Average label'}
                value={methods.watch("ratingSettings.label.mid") ?? ""}
                onChangeHandler={(e: any) => {
                  methods.setValue(
                    "ratingSettings.label.mid",
                    e
                  );
                  methods.clearErrors();
                  setRedoState([]);
                }}
                maxCount={24}
              />
              <InputWithCounter
                placeHolder={'Max label'}
                value={methods.watch("ratingSettings.label.end") ?? ""}
                onChangeHandler={(e: any) => {
                  methods.setValue(
                    "ratingSettings.label.end",
                    e
                  );
                  methods.clearErrors();
                  setRedoState([]);
                }}
                maxCount={24}
              />
            </>
          }
        </>
      )
    }
  }

  const renderIsMultipleField = (fields: any) => {
    if (fields === "isMultiple" && inputType === "dropdown") {
      return (
        <RadioSectionContainer>
          <RadioTitleSectionContainer>
            Multiple Selection
          </RadioTitleSectionContainer>
          <CustomizedSwitch
            checked={methods.watch("isMultiple") ?? false}
            changeHandler={(e: any) => {
              storeHistory(fields, e.target.checked, "formsettings");
              methods.setValue("isMultiple", e.target.checked);
              setRedoState([]);
            }}
          />
        </RadioSectionContainer>
      );
    }
    return <React.Fragment />;
  };

  const renderEmployeeType = (fields: any, index: number) => {
    if (selectedType === "employee" && fields === "organizationChartId") {
      return (
        <div className="render-employee-container" style={{ display: "flex", margin: "10px 0", alignItems: "center", justifyContent: "center" }} >
          <TypeSectionContainer isLargeScreen={!isLessThan1280}>
            <TypeTitleSectionContainer isLargeScreen={!isLessThan1280}>
              Organization
            </TypeTitleSectionContainer>
            <CustomizedSingleSelectDropdown
              value={formValidator.getValues(fields) ?? ""}
              setValue={(value: string) => {
                storeHistory(fields, value, "formsettings");
                setRedoState([]);
                formValidator.setValue(fields, value);
              }}
              dataProvider={chartList}
            />
          </TypeSectionContainer>
        </div>
      );
    }

    return <React.Fragment />;
  };

  if (landingPage && prevSelected.index === -1) {
    return (
      <LandingPageSettings
        editUUID={editUUID}
        dataFromModal={dataFromModal}
        setDataFromModal={setDataFromModal}
      />
    );
  }

  return (
    <RootContainer>
      {
        typeof selectedData.index === 'number' &&
        <form onSubmit={methods.handleSubmit(onSubmit)} style={{ height: "100%" }}>
          <FormProvider {...methods}>
            <OptionalComponents
              selectedType={selectedType}
              hasOptions={hasOptions(inputType)}
              hasSelectOrMultiSelect={hasSelect(inputType)}
              allQuestionFormData={allQuestionFormData}
              setQuestionFormData={setQuestionFormData}
              setAllValues={setAllValues}
              setSelectedData={setSelectedData}
              historyState={historyState}
              renderType={() => {
                return (
                  <TypeSectionContainer isLargeScreen={!isLessThan1280}>
                    <TypeTitleSectionContainer isLargeScreen={!isLessThan1280}>
                      Type
                    </TypeTitleSectionContainer>
                    <CustomizedSingleSelectDropdown
                      value={inputType}
                      setValue={(value: string) => handleTypeChange(value)}
                      dataProvider={dropdownMenu}
                    />
                  </TypeSectionContainer>
                )
              }}
              renderSettings={() => {
                return Object.entries(masterType).map(([fields, value], index) => {
                  return (
                    <React.Fragment>
                      {renderTitleField(fields, index)}
                      {renderPaymentField(fields, index)}
                      {renderCurrencyField(fields, index)}
                      {renderAmountField(fields, index)}
                      {renderIsRequiredField(fields, index)}
                      {renderYesNoToggle(fields)}
                      {renderVariableRule(fields)}
                      {renderIsOtherEnabledField(fields, index)}
                      {renderIsTimeRequiredField(fields, index)}
                      {renderAppointmentField(fields, index)}
                      {renderIsSearchEnabled(fields, index)}
                      {renderCallApiOnSelection(fields)}
                      {renderDropDependedName(fields)}
                      {renderRatingType(fields, index)}
                      {renderSendFileToApi(fields)}
                      {renderFetchFromAPIField(fields, index)}
                      {renderIsMultipleField(fields)}
                      {renderEmployeeType(fields, index)}
                      {fields === "fetchFromApi" &&
                        isfetchFromApi &&
                        Object.entries(methods.formState.errors).length > 0 &&
                        [
                          "dropdown_endPointHeaders",
                          "dropdown_endPoint",
                          "dropdownApiData",
                          "dropdown_maxVal",
                        ].includes(Object.entries(methods.formState.errors)[0][0]) && (
                          <p className="warn">
                            {Object.entries(methods.formState.errors)[0][0] ===
                              "dropdown_endPoint" &&
                              (Object.entries(methods.formState.errors)[0][1] as any)
                                ?.type === "custom"
                              ? (Object.entries(methods.formState.errors)[0][1] as any)
                                ?.message
                              : Object.entries(methods.formState.errors)[0][0]}{" "}
                            is required
                          </p>
                        )}
                      {/* {render} */}
                    </React.Fragment>
                  );
                });
              }}
              renderOptions={() => {
                if (hasOptions(inputType)) {
                  return Object.entries(masterType).map(([fields, value], index) => {
                    return renderOptionsPanel(fields, index, value)
                  })
                } else {
                  return <React.Fragment />;
                }
              }}
              renderQuantity={() => {
                if (methods.watch("isQuantity") === undefined) {
                  methods.setValue("isQuantity", false);
                }

                return (
                  <RadioSectionContainer>
                    <RadioTitleSectionContainer>
                      Quantity Button
                    </RadioTitleSectionContainer>
                    <CustomizedSwitch
                      checked={methods.watch("isQuantity")}
                      changeHandler={(event: React.ChangeEvent<HTMLInputElement>) => {
                        storeHistory("isQuantity", methods.watch("isQuantity"), "formsettings");
                        methods.setValue("isQuantity", event.target.checked);
                      }}
                    />
                  </RadioSectionContainer>
                )
              }}
              renderStyles={() => {
                return Object.entries(masterType).map(
                  ([fields, value], index) => {
                    return fields === "styles" ? (
                      <CustomCss
                        key={`${fields} ${index} ${selectedType}`}
                        customKey={`${fields} ${index}`}
                        editUUID={editUUID}
                        methods={methods}
                        dataFromModal={dataFromModal}
                        storeHistory={storeHistory}
                      />
                    ) : (
                      <React.Fragment />
                    );
                  }
                );
              }}
            />
            {
              Object.entries(methods.formState.errors).length > 0 && !['dropdown_endPointHeaders', 'dropdown_endPoint', 'dropdown_endPoint', 'dropdown_maxVal'].includes(Object.entries(methods.formState.errors)[0][0]) ? <p className='warn'>{Object.entries(methods.formState.errors)[0][0] === "title" ? "Question" : Object.entries(methods.formState.errors)[0][0] === "name" ? "Parameter name" : Object.entries(methods.formState.errors)[0][0]} is required</p> : <></>
            }
            <PaymentDetailsModal
              isOpen={paymentDetails}
              renderContent={() => {
                return (
                  <PaymentPopUp
                    setToastr={setToastr}
                    setErrorType={setErrorType}
                    setErrorMessage={setErrorMessage}
                    setPaymentDetails={setPaymentDetails}
                    paymentUUID={methods.getValues('paymentId')}
                    selectedData={selectedData}
                    handleDelete={handleDelete}
                    handleCancel={() => setPaymentDetails(false)}
                  />
                )
              }}
            />
          </FormProvider>
        </form>
      }
      <ResponseFormatModal
        isOpen={openCodePopup}
        closeHandler={() => setOpenCodePopup(false)}
      />
      <Snackbar
        open={toastr}
        autoHideDuration={3000}
        onClose={() => setToastr(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <Alert variant="filled" onClose={() => setToastr(false)} severity={errorType}>
          {errorMessage}
        </Alert>
      </Snackbar>
    </RootContainer>
  )
}

export default FormSettings